import { memo, useState } from 'react'
import cn from 'classnames'

import { Skeleton } from '~/shared/ui/Skeleton'

import { AVATAR_INITIALS_RATIO } from './config'
import { getInitials } from './utils'
import type { AvatarProps } from './types'

import styles from './Avatar.module.scss'

/**
 * Круглый аватар. Порядок источников: фото → кастомный фолбэк (собачка по роли) →
 * инициалы → скелетон на время загрузки. При ошибке загрузки фото — откат на фолбэк.
 */
export const Avatar = memo(function Avatar(props: AvatarProps) {
  const { size, src, name, glow = 'NONE', isLoading = false, border = 'NONE', fallback } = props
  const [hasImageError, setHasImageError] = useState(false)

  if (isLoading) {
    return <Skeleton shape='CIRCLE' width={size} height={size} />
  }

  const showImage = Boolean(src) && !hasImageError

  return (
    <div
      className={cn(styles.root, styles[`glow_${glow}`], styles[`border_${border}`])}
      style={{ width: size, height: size }}
    >
      {showImage ? (
        <img className={styles.image} src={src} alt='' onError={() => setHasImageError(true)} />
      ) : fallback ? (
        <div className={styles.fallback}>{fallback}</div>
      ) : (
        <div
          className={styles.initials}
          style={{ fontSize: Math.round(size * AVATAR_INITIALS_RATIO) }}
        >
          {getInitials(name)}
        </div>
      )}
    </div>
  )
})
